import {GQL_LocationTranslationsInput} from '../../../generated/graphql'
import {NON_CANONICAL_LOCATION_TRANSLATION_LANGUAGES} from '../translationLanguages'
import {LocationTranslationsForm} from './AddLocation'

// Build the GraphQL translations input for a Location. English is always present (taken from the
// top-level Description field, required by the form). Non-canonical languages are included only
// when they have non-empty content — partial coverage must not activate the row's all-or-nothing
// claim and hide remaining catalog entries.
export const buildLocationTranslationsInput = (englishDescription: string, translations: LocationTranslationsForm): GQL_LocationTranslationsInput => {
  const result: GQL_LocationTranslationsInput = {
    en: {description: englishDescription},
  }
  for (const lang of NON_CANONICAL_LOCATION_TRANSLATION_LANGUAGES) {
    const description = translations[lang].description.trim()
    if (description) {
      result[lang] = {description}
    }
  }
  return result
}
